import Vue from 'vue'
import Router from 'vue-router'
// import API_login from '@api/login'
import {
  Message
} from 'element-ui';
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
import store from '../vuex/store';
import websiteMenu from './websiteMenu';
import backMenu from './back';
Vue.use(Router)
let baseRoutes = [
  // 默认路由
  {
    path: '/',
    redirect: '/website'
  },
  // 后台
  {
    path: '/backlogin',
    name: 'login',
    component: resolve => require(['@/components/back/login/index'], resolve),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/back',
    name: 'back',
    component: resolve => require(['@/components/back/index'], resolve),
    redirect: '/back/movement',
    meta: {
      keepAlive: false
    },
    children:[...backMenu]
  },
  // 官网
  {
    path: '/website',
    name: 'website',
    redirect: '/website/home',
    component: resolve => require(['@/components/website/index'], resolve),
    children:[...websiteMenu]
  },
  // 404页面添加到最后
  {
    path: '*',
    name: 'notFount',
    component: resolve => require(['@/components/404/index'], resolve),
  }
]

let router = new Router({
  routes: baseRoutes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js